module.exports = __webpack_public_path__ + "img/game_2.1bb48eee.png";